const defaultSocketOptions = {
  path: process.env.REACT_APP_SOCKET_BASE_URL,
  transports: ["polling"],
  reconnectionDelay: 250,
};

export default defaultSocketOptions;
